import React, { useState } from "react";
import { FormControl, InputLabel, OutlinedInput, IconButton, InputAdornment, Input } from "@material-ui/core";
import PropTypes from 'prop-types';
import { Tooltip } from "@material-ui/core";
import NumberFormat from 'react-number-format';
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { IMaskInput } from 'react-imask';
import { VisibilityOffIcon, VisibilityOnIcon } from "../../../assets/svg";
import { BLUE_EIGHT, GRAY_FIFTEEN } from "../../../theme";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing.unit,

    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(0px, -6px) scale(0.75)"
    }
  },
  cssLabel: {
    color: BLUE_EIGHT,
    fontSize: "0.72vw",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: "bold",
    lineHeight: "15px",
    '&$cssFocused': {
      color: BLUE_EIGHT,
    },
  },
  cssFocused: {},
  cssUnderline: {
    color: `${GRAY_FIFTEEN} !important`,
    "& .MuiInputBase-input": {
      color: `${GRAY_FIFTEEN} !important`,
    },
    '&:after': {
      borderBottomColor: BLUE_EIGHT,
    },
  },
}));

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="###-####-#######-#"
      definitions={{
        '#': /^[0-9A-Za-z\s\-]+$/, ///[1-9]/
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      format="###-####-#######-#"
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
});


export const FormInput = ({
  error = false,
  label,
  onChange,
  required = false,
  disabled = false,
  value,
  type = "text",
  name,
  hideLabel = false,
}) => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);

  const handleMouseDownPassword = (event) => event.preventDefault();
  return (
    <FormControl
      className={clsx(classes.margin)}
      variant="outlined"
      fullWidth
      error={error}
      size={"small"}
    >
      {!hideLabel && (
        <InputLabel classes={{
          root: classes.cssLabel,
          focused: classes.cssFocused,
        }}
          required={required}
          htmlFor="outlined-blue-field">
          {label}
        </InputLabel>
      )}

      <Input
        id="custom-css-standard-input"
        classes={{
          underline: classes.cssUnderline,
        }}
        disabled={disabled}
        required={required}
        color={BLUE_EIGHT}
        type={type === "password" && showPassword ? "text" : type}
        style={{ borderRadius: "7px" }}
        value={value}
        labelWidth={
          hideLabel
            ? 0
            : label === "VAT"
              ? 35
              : label === "Search by School Id or SchoolName"
                ? 260
                : label === "Emirates ID Number"
                  ? 144
                  : label === "Password"
                    ? 74
                    : label === "Email address"
                      ? 100
                      : 125
        }

        inputComponent={(name === "emirateId" || name === "emiratesId" || name === "parentEmiratesId") ? TextMaskCustom : 'input'}
        onChange={onChange(name)}
        endAdornment={
          type === "password" ? (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                style={{
                  fontSize: "13px",
                  height: "20px",
                  width: "45px",
                  fontWeight: "bold",
                  color: "#006E7D",
                  paddingBottom: 20
                }}
                onClick={() => setShowPassword(!showPassword)}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOnIcon /> : <VisibilityOffIcon />}
              </IconButton>
            </InputAdornment>
          ) : label === "Emirates ID Number" ? (
            <InputAdornment position="end">
              <Tooltip title="Emirate ID" placement="top" arrow>
                <IconButton
                  style={{
                    fontSize: "18px",
                    outline: "none",
                    marginLeft: 25,
                  }}
                >
                  <i className="fas fa-question-circle"></i>
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ) : (
            ""
          )
        }
      />
    </FormControl>
  );
};
